export default "__VITE_ASSET__BKhlSaWj__"